import escapeHtml from 'escape-html';
import { parseText } from './pipeMarkup/textMarkupParser';
import './pipeMarkup/parsers';

export function pipeMarkupParser(text?: string): string {
  if (!text) return '';

  return parseText(escapeHtml(text));
}
